import Web3 from 'web3';

import { AuctionHouseService } from './auction-house.service';
import { CashierService } from './cashier.service';
import { Erc20Service } from './erc20.service';
import { Erc1155Service } from './erc1155.service';
import { LootboxService } from './lootbox.service';
import { SigningService } from './signing.service';
import { StakingService } from './staking.service';
import { TradeService } from './trade.service';

/**
 * Collection of all Web3 service instances
 */
export interface IWeb3Services {
  tradeService: TradeService;
  erc20Service: Erc20Service;
  auctionHouseService: AuctionHouseService;
  lootboxService: LootboxService;
  erc1155Service: Erc1155Service;
  cashierService: CashierService;
  stakingService: StakingService;
  signingService: SigningService | null;
}

/**
 * Factory for creating Web3 service instances
 * Centralizes service instantiation and manages dependencies
 */
export class Web3ServiceFactory {
  constructor(private web3: Web3, private ethereum?: any, private torusProvider?: any) {}

  createTradeService(): TradeService {
    return new TradeService(this.web3, this.torusProvider);
  }

  createErc20Service(): Erc20Service {
    return new Erc20Service(this.web3, this.torusProvider);
  }

  createAuctionHouseService(): AuctionHouseService {
    return new AuctionHouseService(this.web3, this.torusProvider);
  }

  createLootboxService(): LootboxService {
    return new LootboxService(this.web3, this.torusProvider);
  }

  createErc1155Service(): Erc1155Service {
    return new Erc1155Service(this.web3, this.torusProvider);
  }

  createCashierService(): CashierService {
    return new CashierService(this.web3, this.torusProvider);
  }

  createStakingService(): StakingService {
    return new StakingService(this.web3, this.torusProvider);
  }

  createSigningService(): SigningService {
    if (!this.ethereum) {
      throw new Error('Ethereum provider is required for SigningService');
    }
    return new SigningService(this.ethereum);
  }

  /**
   * Creates all services at once
   */
  createAllServices(): IWeb3Services {
    return {
      tradeService: this.createTradeService(),
      erc20Service: this.createErc20Service(),
      auctionHouseService: this.createAuctionHouseService(),
      lootboxService: this.createLootboxService(),
      erc1155Service: this.createErc1155Service(),
      cashierService: this.createCashierService(),
      stakingService: this.createStakingService(),
      signingService: this.ethereum ? this.createSigningService() : null,
    };
  }
}
